<template>
    <vx-expandable-card>
        <template v-slot:header> Source Team </template>
        <template v-slot:content>
            <vx-selectable
                v-model="model.source_team"
                :options="teams"
                @search="searchTeams"
                :error="displayFirstError(validate.source_team)"
                label="name"
                size="lg"
                :clearable="true"
            ></vx-selectable>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxSelectable } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { ref } from 'vue';
import { adminCloningClient } from '~/services';
import debounce from '~/utils/debounce';
import { displayFirstError } from '~/utils/validation';

const model = defineModel('form', {
    type: Object,
    required: true,
});

const validate = useVuelidate(
    {
        source_team: {
            required,
        },
    },
    model
);

const teams = ref([]);
const loadingTeams = ref(false);
const searchTeams = debounce((search) => {
    if (loadingTeams.value) {
        return;
    }

    loadingTeams.value = true;

    adminCloningClient
        .getTeams({
            query: search,
            sort_field: 'id',
            sort_dir: 'desc',
            per_page: 100,
        })
        .then((response) => {
            teams.value = response.data.data.map((team) => ({
                ...team,
                name: `${team.id} - ${team.name}`,
            }));
        })
        .finally(() => (loadingTeams.value = false));
}, 350);

searchTeams('');
</script>
